import React from "react";
import './Companies.css';


const Companies = () => {
    return (
        <>
            <section className="c-wrapper">
                <div className="flexCenter paddings innerWidth c-container">

                    <img src="./images/prologis.png" alt="" />
                    <img src="./images/tower.png" alt="" />
                    <img src="./images/equinix.png" alt="" />
                    <img src="./images/realty.png" alt="" />
                </div>
        
            </section>
        </>
    )
}

export default Companies;
